import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { AdvancedFiltersService } from '@qaroni-core/services/app/advanced-filters/advanced-filters.service';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';

@Component({
  selector: 'qaroni-advanced-filters-container',
  templateUrl: './advanced-filters-container.component.html',
  styleUrl: './advanced-filters-container.component.scss',
  animations: [qaroniAnimations.toggleHeight()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AdvancedFiltersContainerComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  private advancedFiltersService = inject(AdvancedFiltersService);
  private _cdr = inject(ChangeDetectorRef);
  private advancedFilterStatus$ =
    this.advancedFiltersService.getAdvancedFiltersStatus$();

  public active = false;

  ngOnInit(): void {
    this.subs.add(this.advancedFilterStatus$.subscribe(this.getStatus));
  }

  private getStatus = (status: boolean): void => {
    this.active = status;
    this._cdr.markForCheck();
  };
}
